<template>
	<div
		class="ms-combobox flex ms-editor"
		:class="{ isValid: errorProvider.isValid, disabled: disabled }"
	>
		<input
			ref="input"
			class="input"
			:placeholder="placeholder"
			v-model="internalText"
			v-on="listeners"
			@click="onInputClick"
			:disabled="disabled"
			:maxlength="maxLength"
			:readonly="readOnly"
			:class="{ disabled: disabled }"
		/>
		<div
			class="icon-input"
			v-tooltip="{
				content: errorProvider.message,
				show: focused,
				classes: `error`,
			}"
			v-if="errorProvider.isValid"
		>
			<div class="mi mi-20 mi-icon-error mr-2"></div>
		</div>
		<div
			@click="expand(!expanded)"
			class="icon-combo--dropdown"
			:class="{ disabled: disabled }"
		>
			<slot name="dropdownIcon">
				<div :class="['mi', 'mi-24', 'mi-arrow-dropdown']"></div>
			</slot>
		</div>
		<ms-combo-box-dropdown
			ref="dropdownPanel"
			v-if="expanded"
			:topx="dropdownTopx"
			:leftx="dropdownLeftx"
			:maxWidthx="dropdownMaxWidthx"
			:minWidthx="dropdownMinWidthx"
			:columnx="columns"
			:comboType="comboType"
			:emptyText="internalDataSource && internalDataSource.length > 0 ? '' : 'Không có dữ liệu'"
		>
			<MsRecycleScroller
				ref="scroller"
				:style="styleScroller"
				:items="internalDataSource"
				:itemSize="itemSize"
				:keyField="keyField"
				:emitUpdate="true"
				:buffer="0"
				:visiableIndex="typeAheadPointer"
				@visible="onScrollerVisible"
				@update="onScrollerUpdate"
			>
				<template v-slot="{ item, index }">
					<ms-combo-box-item
						:comboType="comboType"
						:item="item"
						:columnx="columns"
						:valueField="valueField"
						:displayField="displayField"
						:class="{
							'ms-combobox-item--highlight': typeAheadPointer == index,
						}"
						@click.stop="onItemClick(item, $event)"
					></ms-combo-box-item>
				</template>
			</MsRecycleScroller>
		</ms-combo-box-dropdown>
	</div>
</template>
<script>
import MsComboBoxDropdown from './MsComboBoxDropdown.vue';
import MsComboBoxItem from './MsComboBoxItem.vue';
import MsRecycleScroller from '@/components/msvirtualscroller/MsRecycleScroller';
import commonFunc from '@/common/commonFunction.js';
import msBaseComponent from '@/components/msbase/msBaseComponent.vue';
import EventBusGlobal, { GlobalEventName } from '@/sys/eventBusGlobal';
export default {
	name: 'msCombobox',
	extends: msBaseComponent,
	components: { MsComboBoxDropdown, MsRecycleScroller, MsComboBoxItem },
	inheritAttrs: false,
	props: {
		value: {},
		placeholder: {
			default: null,
			type: [Number, String],
		},
		maxItemsDisplay: {
			default: 5,
			type: Number,
		},
		columns: {
			type: Array,
			default: () => [],
		},
		/**
		 * Trường làm value
		 * CreatedBy LTDAT 15.06.2020
		 */
		valueField: {
			type: String,
			default: null,
		},
		/**
		 * Trường làm text display
		 * CreatedBy LTDAT 15.06.2020
		 */
		displayField: {
			type: String,
			default: null,
		},
		//Dữ liệu của combobox
		data: {
			default: () => [],
			type: Array,
		},
		//Độ rộng của 1 item
		itemSize: {
			default: 32,
			type: Number,
		},
		//Chỉ nhận giá trị có trong danh sách
		forceSelection: {
			default: true,
			type: Boolean,
		},
		//Là combotree hay không
		isComboTree: {
			default: false,
			type: Boolean,
		},
		//Parent Field
		idProperty: {
			default: null,
			type: String,
		},
		//Field chứa parentID
		parentIdProperty: {
			default: 'ParentID',
			type: String,
		},
		//Không cho phép chọn trường là cha
		notSelectionParent: {
			default: false,
			type: Boolean,
		},
		//Chế độ filter chỉ hiển thị con và cha của nó khi tìm kiếm (không hiển thị anh em)
		filterChildrenOnly: {
			default: false,
			type: Boolean,
		},
		//Độ rông của dropdown tính bằng px
		dropdownWidth: {
			default: null,
			type: [String, Number],
		},
		//Store xử lý dữ liệu trên liên quan đến data trong grid
		store: {
			default: null,
		},
		//Mode query lấy dữ liệu từ server hay client
		queryMode: {
			type: String,
			default: 'remote',
		},
		remoteFilter: {
			type: Boolean,
			default: false,
		},
		//Gán giá trị text lúc ban đầu
		initText: {
			default: null,
			type: [Number, String],
		},
		//Trạng thái có phân trang hay không
		pagination: {
			default: false,
			type: Boolean,
		},
		//Combo mặc định chọn bản ghi theo index
		initIndex: {
			default: -1,
			type: Number,
		},
		disabled: {
			default: false,
			type: Boolean,
		},
		autoLoad: {
			default: false,
			type: Boolean,
		},
		display: {},
		//Tổng số bản ghi
		pageTotal: {
			default: 0,
			type: Number,
		},
		mappingField: {
			default: null,
		},
		firstExpandLoad: {
			default: false,
			type: Boolean,
		},
		keyField: {
			default: '__vKeyValue',
			type: String,
		},
		maxLength: {
			default: null,
			type: Number,
		},
		readOnly: {
			default: false,
			type: Boolean,
		},
	},
	computed: {
		listeners() {
			const me = this;
			return {
				input: (event) => me.onInput(event),
				focus: (event) => me.onFocus(event),
				change: (event) => me.onChange(event),
				blur: (event) => me.onBlur(event),
				keydown: (event) => me.onKeydown(event),
			};
		},
		//Tính độ rộng của dropdown combobox để scroll
		styleScroller() {
			const me = this;
			return { 'max-height': me.maxItemsDisplay * me.itemSize + 'px' };
		},
	},
	data() {
		const me = this;
		me.initStaticData();
		return {
			internalDataSource: [],
			internalText: null,
			expanded: false,
			dropdownTopx: 0,
			dropdownLeftx: 0,
			internalSelectedItem: null,
			typeAheadPointer: -1,
			focused: false,
		};
	},
	//Hàm khởi tạo dữ liệu hook func
	async created() {
		const me = this;
		me.initCombo();
		me.setInitIndex();
		me.initData();
		if (me.autoLoad) {
			me.doQueryInternal(null, false);
		}
		EventBusGlobal.$on(GlobalEventName.scrollEvent, me.scrollEvent);
		EventBusGlobal.$on('clickEventOther', me.click_out);
		if (me.mappingField) {
			for (let key in me.mappingField) {
				me.$options.propsData[key] = null;
			}
		}
		// me.initData();
		// me.setInitText();
	},
	mounted() {
		const me = this;
		//Debounce query để delay load
		if (me.queryMode != 'remote') {
			me.internalQueryDelay = 20;
		}
		me.doQuery = _.debounce(me.doQueryInternal, me.internalQueryDelay);
		if (me.store) {
			me.store.pageAppend = true;
		}
	},
	beforeDestroy() {
		const me = this;
		me.expand(false);
		if (me.$refs.dropdownPanel) {
			me.$refs.dropdownPanel.$el.remove();
		}
		EventBusGlobal.$off(GlobalEventName.scrollEvent, me.scrollEvent);
		EventBusGlobal.$off('clickEventOther', me.click_out);
		document.removeEventListener('click', me.click_out);
	},
	methods: {
		/**
		 * Bắt sự kiện khi scroll trên chương trình thì đóng combobox lại
		 * Created by LTDAT
		 */
		scrollEvent(e) {
			const me = this;
			if (me.expanded) {
				this.expand(false);
			}
		},
		/**
		 * Mặc định chọn giá trị theo index ban đầu
		 * Created by LTDAT
		 */
		setInitIndex() {
			const me = this;
			if (
				me.initIndex >= 0 &&
				me.internalDataSource &&
				me.internalDataSource.length > 0 &&
				me.typeAheadPointer < 0
			) {
				me.typeAheadPointer = me.initIndex;
				me.setInternalItem(me.internalDataSource[me.typeAheadPointer], false);
			}
		},
		/**
		 * Kiểm tra scroll đã đến bản ghi cuối cùng hay chưa
		 * Nếu load theo kiểu phân trang và số bản ghi trong combo nhỏ hơn tổng số bản ghi thi load tiếp dữ liệu vào store
		 * @param start: vị trí bắt đầu của view trong vitual scroll
		 * @param end: vị trí kết thúc của view trong vitual scroll
		 * Created by LTDAT(30.06.2020)
		 *  */
		onScrollerUpdate(start, end) {
			const me = this;
			if (me.pagination) {
				if (
					end == me.internalDataSource.length &&
					end < me.pageTotal &&
					start == me.internalDataSource.length - 5
				) {
					let payload = {
						Skip: me.internalDataSource.length,
						Take: me.internalDataSource.length + 20,
						pageAppend: true,
					};
					me.$emit('loadData', payload);
				}
			}
		},
		/**
		 * Set giá trị hiện thị ban đầu cho combobox khi combo chưa có dữ liệu
		 * Created by LTDAT(25.06.2020)
		 */
		setInitText() {
			const me = this;
			me.internalText = me.initText;
		},
		/**
		 * Thực hiện query dữ liệu, có thể từ local hoặc remote tùy theo cấu hình
		 * CreatedBy LTDAT 11/12/2019
		 */
		doQueryInternal(searchString, expand = true) {
			let me = this,
				event = { preventDefault: false, sender: me },
				queryString = searchString != null ? searchString : me.getQueryString();
			me.$emit('beforeQuery', event);
			if (event.preventDefault) {
				return false;
			}
			if (me.lastQueryString == queryString) {
				me.expand(expand);
			} else {
				me.lastQueryString = queryString;
				me.querying = true;
				me.typeAheadPointer = -1;
				if (me.queryMode === 'remote') {
					me.doRemoteQuery(queryString).then((x) => {
						commonFunc.genVKeyValue(me.internalDataSource);
						me.afterQuery(expand);
					});
				} else {
					me.doLocalQuery(queryString).then((x) => me.afterQuery(expand));
				}
			}
		},
		/**
		 * Xử lý sau khi query xong dữ liệu
		 * CreatedBy LTDAT 24.06.2020
		 */
		afterQuery(expand) {
			const me = this;
			me.expand(expand);
		},
		/**
		 * Query dữ liệu api
		 * CreatedBy LTDAT 24.06.2020
		 */
		doRemoteQuery(queryString, expand) {
			//Build filter,
			let me = this,
				filters = [],
				filterFields = me.filterFields;
			return new Promise((resolve, reject) => {
				if (queryString) {
					for (const key in filterFields) {
						if (filterFields.hasOwnProperty(key)) {
							const f = filterFields[key];
							let filter = {
								property: key,
								value: queryString,
								operator: f,
								operand: 'or',
							};
							filters.push(filter);
						}
					}
				}
				let payload = {};
				if (me.pagination) {
					payload.Skip = 0;
					payload.Take = 20;
					payload.pageAppend = false;
				}
				me.$emit('loadData', payload);
			});
		},
		/**
		 * Query dữ liệu local
		 * CreatedBy LTDAT 24.06.2020
		 */
		doLocalQuery(queryString) {
			let me = this,
				store = me.store;

			return new Promise((resolve, reject) => {
				//Kiểm xem store đã load dữ liệu chưa, nếu chưa thì load lần đầu
				let p;
				if (me.autoLoad && store && !store._loaded && store.getCount() == 0) {
					let proxy = store.proxy;
					if (proxy && proxy.type === 'cache') {
						p = store.load();
					}
				}
				p ? p.then(resolve, reject) : resolve(false);
			}).then(() => {
				me.loading = false;
			});
		},
		/**
		 * Filter tree chỉ hiển thị con và cha của nó
		 * CreatedBy: Yêu cầu mới
		 * Refactored: Tách logic + tối ưu performance (giảm từ O(3n) xuống O(n))
		 */
		filterTreeChildrenOnly(queryString) {
			const me = this;

			// Early return cho các trường hợp đặc biệt
			if (!queryString || !me.data || me.data.length === 0) {
				me.initData();
				me.typeAheadPointer = -1;
				return;
			}

			// Tìm matched children và parents trong 1 lần duyệt
			const { matchedChildren, parentsMap } = me._findMatchedItemsAndParents(
				queryString
			);

			// Nếu không tìm thấy con nào thì hiển thị empty
			if (matchedChildren.length === 0) {
				me.internalDataSource = [];
				me.typeAheadPointer = -1;
				return;
			}

			// Build tree và update datasource
			me._updateDataSourceWithFilteredTree(matchedChildren, parentsMap);

			// Highlight node con đầu tiên
			me.typeAheadPointer = me._findFirstChildIndex(me.internalDataSource);
		},
		/**
		 * Tìm các item con match với query và các node cha của chúng trong 1 lần duyệt
		 * @param {string} queryString - Chuỗi tìm kiếm (đã được trim ở getQueryString)
		 * @returns {{matchedChildren: Array, parentsMap: Map}} - Danh sách con match và Map các cha
		 * @private
		 */
		_findMatchedItemsAndParents(queryString) {
			const me = this;
			const matchedChildren = [];
			const parentsMap = new Map();
			const searchValue = queryString.toLowerCase().trim();

			// Bước 1: Build Map tất cả các item theo ID để tra cứu nhanh
			const allItemsMap = new Map();
			me.data.forEach((item) => {
				allItemsMap.set(item[me.idProperty], item);
			});

			// Bước 2: Tìm children match và lưu parentId cần thiết
			const parentIdsNeeded = new Set();
			me.data.forEach((item) => {
				const parentId = item[me.parentIdProperty];

				// Chỉ tìm kiếm trên các node con (có parentId)
				if (parentId && me._matchItemWithQuery(item, searchValue)) {
					matchedChildren.push(item);
					parentIdsNeeded.add(parentId);
				}
			});

			// Bước 3: Lấy các parent cần thiết từ Map
			parentIdsNeeded.forEach((parentId) => {
				const parent = allItemsMap.get(parentId);
				if (parent) {
					parentsMap.set(parentId, parent);
				}
			});

			return { matchedChildren, parentsMap };
		},
		/**
		 * Kiểm tra item có match với query string không
		 * @param {Object} item - Item cần kiểm tra
		 * @param {string} searchValue - Giá trị tìm kiếm (đã lowercase)
		 * @returns {boolean} - true nếu match
		 * @private
		 */
		_matchItemWithQuery(item, searchValue) {
			const me = this;

			for (const key in me.filterFields) {
				if (me.filterFields.hasOwnProperty(key) && item[key]) {
					const itemValue = item[key].toString().toLowerCase();
					const operator = me.filterFields[key];

					const isMatch =
						operator === 'contains'
							? itemValue.includes(searchValue)
							: itemValue.startsWith(searchValue);

					if (isMatch) {
						return true;
					}
				}
			}

			return false;
		},
		/**
		 * Update datasource với filtered tree data
		 * @param {Array} matchedChildren - Danh sách con đã match
		 * @param {Map} parentsMap - Map các node cha cần hiển thị
		 * @private
		 */
		_updateDataSourceWithFilteredTree(matchedChildren, parentsMap) {
			const me = this;

			// Kết hợp cha và con
			const parentsArray = Array.from(parentsMap.values());
			const filteredData = [...parentsArray, ...matchedChildren];

			// Build tree structure
			const dataTree = me._buildTreeFromFilteredData(filteredData);
			me.internalDataSource = commonFunc.getBodyData(dataTree, true);
		},
		/**
		 * Build tree structure từ filtered data
		 * @param {Array} filteredData - Dữ liệu đã filter
		 * @returns {Array} - Tree structure
		 * @private
		 */
		_buildTreeFromFilteredData(filteredData) {
			const me = this;
			// Clone data để tránh mutate data gốc
			const clonedData = JSON.parse(JSON.stringify(filteredData));
			return commonFunc.nomalizeDataTree(
				clonedData,
				me.idProperty,
				me.parentIdProperty
			);
		},
		/**
		 * Tìm index của node con đầu tiên (không phải cha)
		 * @param {Array} dataSource - Datasource cần tìm
		 * @returns {number} - Index của node con đầu tiên, -1 nếu không tìm thấy
		 * @private
		 */
		_findFirstChildIndex(dataSource) {
			return dataSource.findIndex((item) => !item.isParent);
		},
		/**
		 * Reset data về ban đầu cho chế độ filterChildrenOnly
		 * CreatedBy: Feature mới
		 */
		resetFilteredData() {
			const me = this;
			if (me.filterChildrenOnly && me.isComboTree && me.queryMode === 'local') {
				if (!me.internalText || me.internalText.trim() === '') {
					me.initData();
					me.typeAheadPointer = -1;
				}
			}
		},
		/**
		 * Lấy chuỗi cần query, trường hợp number thì lấy value bỏ qua ký tự phân cách
		 * CreatedBy LTDAT 11/12/2019
		 */
		getQueryString() {
			return (this.internalText || '').trim();
		},
		//Click ra ngoài combo đóng combo lại
		//Created by LTDAT 18.06.2020
		click_out(e) {
			const me = this;
			if (me.expanded) {
				if (
					!commonFunc.hasParent(e.target, me.$el) &&
					!commonFunc.hasParent(e.target, me.$refs.dropdownPanel.$el)
				) {
					me.expand(false);
				}
			}
		},
		//Reset lại các giá trị trong combobox
		reset() {
			const me = this;
			me.internalText = '';
			me.internalSelectedItem = null;
			me.typeAheadPointer = -1;
			me.internalValue = null;
			me.$emit('input', me.internalValue);
		},
		/**
		 * Set giá trị hiển thị
		 * @pram value giá trị hiển thị
		 */
		setInternalText(value) {
			const me = this;
			me.internalText = value;
		},
		/**
		 * Set value cho combo
		 */
		setValue(value, userAction = false) {
			const me = this;
			me.internalValue = value;
			me.$emit('input', me.internalValue);
			me.doHightlightItem();
			if (me.typeAheadPointer >= 0) {
				me.setInternalItem(
					me.internalDataSource[me.typeAheadPointer],
					userAction
				);
			}
		},
		//Sự kiện nhập liệu trên input
		//Created by LTDAT (16.06.2020)
		onInput(e) {
			const me = this;
			if (!me.expanded) {
				me.expand(true);
			}
			if (!me.internalText) {
				if (me.internalValue) {
					let metaData = {
						oldData: me.internalSelectedItem,
						newData: null,
					};
					me.$emit('selected', metaData);
				}
				me.reset();
				// Reset lại data khi xóa hết text
				if (me.filterChildrenOnly && me.isComboTree) {
					me.initData();
				}
			}
			if (me.queryMode == 'remote' && me.remoteFilter) {
				me.doQuery(me.internalText, true);
			} else if (
				me.queryMode == 'local' &&
				me.filterChildrenOnly &&
				me.isComboTree
			) {
				// Xử lý filter local cho chế độ filterChildrenOnly - gọi trực tiếp để highlight ngay
				if (me.internalText) {
					me.filterTreeChildrenOnly(me.internalText);
					// Scroll về đầu danh sách sau khi filter
					me.$nextTick(() => {
						const scroller = me.getScroller();
						if (scroller && me.typeAheadPointer >= 0) {
							scroller.scrollToItem(0, true); // Scroll về đầu
						}
					});
				}
			}
			if (!me.forceSelection && me.valueField == me.displayField) {
				me.internalValue = me.internalText;
				me.$emit('input', me.internalValue);
			}
			// Chỉ tìm index item nếu không phải chế độ filterChildrenOnly
			if (
				!(me.filterChildrenOnly && me.isComboTree && me.queryMode == 'local')
			) {
				me.typeAheadPointer = me.filterIndexItemByText();
				me.adjustScroll();
			}
		},
		//Click vào ô input khi readOnly thì mở/đóng dropdown
		onInputClick(e) {
			const me = this;
			if (me.readOnly && !me.disabled) {
				me.expand(!me.expanded);
			}
		},
		//Sự kiện focus vào input
		//Created by LTDAT (16.06.2020)
		onFocus(e) {
			const me = this;
			me.focused = true;
		},
		//Sự kiện change input
		//Created by LTDAT (16.06.2020)
		onChange(e) {
			const me = this;
			if (me.focused) {
				if (me.forceSelection) {
					me.typeAheadPointer = me.filterIndexItemByText();
					if (me.typeAheadPointer < 0) {
						me.reset();
					}
				} else {
					if (me.valueField == me.displayField) {
						me.internalValue = me.internalText;
						me.$emit('input', me.internalValue);
					} else {
						me.typeAheadPointer = me.filterIndexItemByText();
						if (me.typeAheadPointer < 0) {
							me.internalValue = null;
							let dataEmpty = {};
							dataEmpty[me.valueField] = null;
							dataEmpty[me.displayField] = me.internalText;
							let metaData = {
								oldData: me.internalSelectedItem,
								newData: dataEmpty,
								userAction: false,
							};
							me.$emit('selected', metaData);
							me.$emit('input', me.internalValue);
						}
					}
				}
			}
			me.$emit('change', me.internalValue);
		},
		//Sự kiện blur input
		//Created by LTDAT (16.06.2020)
		onBlur(e) {
			const me = this;
			me.focused = false;
			me.$emit('blur', e);
			// me.validate(me.internalText);
		},
		//Sự kiện keydown input
		//Created by LTDAT (16.06.2020)
		onKeydown(e) {
			const me = this;
			switch (e.which) {
				case 40:
					{
						if (!me.expanded) {
							me.expand(true);
						} else if (me.typeAheadPointer < me.getTotalData() - 1) {
							if (me.notSelectionParent) {
								let typeAheadPointerNext = me.typeAheadPointer + 1;
								for (let i = typeAheadPointerNext; i < me.getTotalData(); i++) {
									me.typeAheadPointer++;
									me.adjustScroll(typeAheadPointerNext);
									if (!me.internalDataSource[i].isParent) {
										break;
									}
								}
							} else {
								me.typeAheadPointer++;
								me.adjustScroll();
							}
						}
					}
					break;
				case 38:
					{
						if (me.expanded) {
							if (me.typeAheadPointer > 0) {
								if (me.notSelectionParent) {
									let typeAheadPointerPre = me.typeAheadPointer - 1;
									for (let i = typeAheadPointerPre; i > 0; i--) {
										me.typeAheadPointer--;
										me.adjustScroll(me.typeAheadPointer);
										if (!me.internalDataSource[i].isParent) {
											break;
										}
									}
								} else {
									me.typeAheadPointer--;
									me.adjustScroll();
								}
							}
						}
					}
					break;
				case 13:
					{
						event.preventDefault();
						if (me.typeAheadPointer >= 0) {
							me.setInternalItem(me.internalDataSource[me.typeAheadPointer]);
						}
						me.expand(false);
					}
					break;
				case 9:
					{
						if (me.expanded) {
							if (me.typeAheadPointer >= 0) {
								me.setInternalItem(me.internalDataSource[me.typeAheadPointer]);
							}
							me.expand(false);
						}
					}
					break;
			}
			me.$emit('keydown', event);
		},
		//Lấy tổng số lượng dữ liệu trong data
		getTotalData() {
			const me = this;
			return me.internalDataSource.length;
		},
		//Bôi màu hightlight cho item
		doHightlightItem() {
			const me = this;
			if (me.internalDataSource) {
				if (me.internalDataSource.length > 0) {
					if (me.internalValue != null && me.internalValue != undefined) {
						//Trước khi load tính toán lại typeAheadPointer nếu cần thiết để scroll di chuyển về dúng vị trí khi show scroller lên
						//Tìm vị trí selectedItem trong source, không lấy selectedIndex vì có thể không chính xác khi source thay đổi
						let index = _.findIndex(
							me.internalDataSource,
							(item) => item[me.valueField] === me.internalValue
						);
						me.typeAheadPointer = index;
					} else {
						me.typeAheadPointer = -1;
					}
				}
			}
		},
		//Tìm kiếm item trong list
		//Created by LTDAT(16.06.2020)
		filterIndexItemByText(queryText, data) {
			const me = this;
			let filters = me.filterFields,
				value = queryText || me.internalText,
				index = -1,
				dataSource = data || me.internalDataSource;
			if (filters && value) {
				value = value.toString();
				index = dataSource.findIndex((item, _index) => {
					let ret = false;
					for (const key in filters) {
						if (filters.hasOwnProperty(key)) {
							const s = filters[key];
							if (s == 'contains') {
								ret =
									item[key] &&
									item[key].toString() &&
									item[key]
										.toString()
										.toLowerCase()
										.contains(value.toLowerCase());
							} else {
								ret =
									item[key] &&
									item[key].toString() &&
									item[key]
										.toString()
										.toLowerCase()
										.startsWith(value.toLowerCase());
							}
							if (ret) {
								break;
							}
						}
					}
					return ret;
				});
			}
			return index;
		},
		//Lấy cột filter để tìm kiếm local
		//Created by LTDAT 16.06.2020
		getFilterFields() {
			let filter = {};

			if (this.columns && this.columns.length > 0) {
				for (let i = 0; i < this.columns.length; i++) {
					const col = this.columns[i];
					if (!col.filterOperator) {
						col.filterOperator = 'contains';
					}
					if (col.dataField && col.filterOperator) {
						if (this.filterColumns && this.filterColumns.length > 0) {
							this.filterColumns.forEach((e) => {
								if (!filter.hasOwnProperty(e)) {
									filter[e] = col.filterOperator;
								}
							});
						} else {
							filter[col.dataField] = col.filterOperator;
						}
					}
				}
			} else {
				filter[this.displayField] = 'contains';
			}
			return filter;
		},
		//Lấy element scroll
		//Created by LTDAT (16.06.2020)
		getScroller() {
			if (this.expanded) {
				return this.$refs['scroller'];
			}
			return null;
		},
		/**
		 * Di chuyển view đến bản ghi nếu cần
		 * @param {Bản ghi cần view} index
		 * CreatedBy LTDAT 16.06.2020
		 */
		adjustScroll(typeAheadPointer = this.typeAheadPointer) {
			let scroller = this.getScroller();
			if (scroller) {
				scroller.scrollToItem(typeAheadPointer, true);
			}
		},
		onScrollerVisible() {
			const me = this;
			me.adjustScroll();
		},
		//Hàm xử lý khi chọn item trên dropdown
		//Created by LTDAT(16.06.2020)
		onItemClick(item, event) {
			const me = this;
			me.setInternalItem(item);
			me.$refs.input.focus();
		},
		//Set giá trị được chọn
		setInternalItem(item, userAction = true) {
			const me = this;

			if (item) {
				if (me.notSelectionParent && item.isParent) {
					return;
				}
				let metaData = {
					oldData: me.internalSelectedItem,
					newData: item,
				};
				me.internalSelectedItem = item;
				me.internalValue = item[me.valueField];
				me.$emit('input', me.internalValue);
				me.internalText = item[me.displayField];
				me.typeAheadPointer = me.findIndexItem(item);
				me.expand(false);
				me.$emit('update:display', me.internalText);
				if (me.mappingField) {
					for (let key in me.mappingField) {
						let emitStrUpdate = 'update:' + key;
						me.$emit(
							emitStrUpdate,
							me.internalSelectedItem[me.mappingField[key]]
						);
					}
				}
				if (userAction == true) {
					me.$emit('selected', metaData);
				} else {
					me.$emit('autoSelected', metaData);
				}
			}
		},
		//Tìm vị trị của item trong data
		findIndexItem(item) {
			const me = this;
			return me.internalDataSource.findIndex((_item) => {
				return _item == item;
			});
		},
		//Khởi tạo dữ liệu tĩnh mặc định
		initStaticData() {
			const me = this;
			me.comboType = 1;

			me.internalQueryDelay = 200;
			me.filterFields = me.getFilterFields();
			me.internalValue = null;
			me.firstExpand = true;
		},
		//Khởi tạo dữ liệu
		initData() {
			const me = this;
			if (me.store) {
				me.internalDataSource = me.store.data.items;
			} else {
				me.internalDataSource = me.data;
			}
			commonFunc.genVKeyValue(me.internalDataSource);
			//Nếu là combo dạng tree
			if (me.comboType == 3) {
				let data = JSON.parse(JSON.stringify(me.internalDataSource));
				let dataTree = commonFunc.nomalizeDataTree(
					data,
					me.idProperty,
					me.parentIdProperty
				);
				me.internalDataSource = commonFunc.getBodyData(dataTree, true);
			}
		},
		/**
		 * Khởi tạo combo
		 *
		 * @author hngiap - 01.09.2019
		 * 1 là combo không có columns (ComboEditor)
		 * 2 là combo có columns
		 * 3 là combo tree
		 */
		initCombo() {
			const me = this;
			if (me.isComboTree) {
				me.comboType = 3;
			} else if (me.columns && me.columns.length !== 0) {
				me.comboType = 2;
			} else {
				me.comboType = 1;
			}
		},
		//Đóng mở combobox
		expand(mode = !this.expanded) {
			const me = this;
			if (me.firstExpand) {
				if ((me.queryMode == 'remote' && !me.autoLoad) || me.firstExpandLoad) {
					me.doQueryInternal(null, true);
				}
				me.firstExpand = false;
			}
			if (mode == true) {
				// Reset data khi mở dropdown
				me.resetFilteredData();
				me.$emit('beforeExpand');
				document.addEventListener('click', me.click_out);
				me.$refs.input.focus();
				me.changeDropdownPosition();
			} else {
				document.removeEventListener('click', me.click_out);
				// Reset data khi đóng dropdown
				me.resetFilteredData();
			}
			me.expanded = mode;
			me.doHightlightItem();
		},
		/**
		 * Hàm set vị trí cho dropdown menu khi expand
		 * TODO: Chưa xử lý khi có scroll
		 */
		changeDropdownPosition() {
			let me = this,
				comboEl = me.$el,
				comboElRect = comboEl.getBoundingClientRect(),
				comboMenuEl = me.$el;

			let windowWidth =
				window.innerWidth ||
				document.documentElement.clientWidth ||
				document.body.clientWidth;

			let windowHeight =
				window.innerHeight ||
				document.documentElement.clientHeight ||
				document.body.clientHeight;

			me.dropdownLeftx = comboElRect.left;
			me.dropdownTopx = comboElRect.top + comboElRect.height + 2;
			me.dropdownMaxWidthx = me.dropdownMinWidthx = me.dropdownWidth
				? me.dropdownWidth
				: comboElRect.width;

			// Nếu chạm phải thì align sang trái
			if (comboElRect.left + comboMenuEl.offsetWidth > windowWidth) {
				me.dropdownLeftx = comboElRect.right - comboMenuEl.offsetWidth;
			}

			// Nếu chạm bottom thì align top
			let maxItemsDisplay = me.maxItemsDisplay;
			if (me.columns && me.columns.length > 0) {
				maxItemsDisplay += 1;
			}
			if (
				comboElRect.bottom + me.itemSize * maxItemsDisplay + 2 >
				windowHeight
			) {
				me.dropdownTopx =
					comboElRect.top -
					(me.itemSize *
						Math.min(maxItemsDisplay, me.internalDataSource.length) +
						4);
			}
		},
	},
	watch: {
		rules: {
			handler(newVal, oldVal) {
				const me = this;
				me.validate();
			},
		},
		data: {
			immediate: true,
			handler(newVal, oldVal) {
				const me = this;
				if (me.internalDataSource != newVal) {
					me.initData();
				}
				me.$nextTick(() => {
					me.doHightlightItem();
					if (
						me.initIndex >= 0 &&
						me.internalDataSource[me.initIndex] &&
						me.typeAheadPointer < 0
					) {
						me.typeAheadPointer = me.initIndex;
					}
					if (me.typeAheadPointer >= 0) {
						me.setInternalItem(
							me.internalDataSource[me.typeAheadPointer],
							false
						);
					}
				});
			},
		},
		/**
		 * Set lại giá trị hiển thị khi giá trị của biến initText thay đổi
		 */
		initText: {
			immediate: true,
			handler(newVal, oldVal) {
				const me = this;
				if (newVal || oldVal) {
					me.setInitText(newVal);
				}
			},
		},
		/**
		 * Kiểm tra nếu text hiện thị thay đổi thi validate
		 */
		internalText: {
			handler(newVal, oldVal) {
				const me = this;
				newVal = newVal ? newVal : '';
				oldVal = oldVal ? oldVal : '';
				if (newVal != oldVal) {
					me.validate();
				}
				// me.$emit('input',newVal);
			},
		},
		/**
		 * Nếu giá trị VModel của combo thay đổi thì gán lại giá trị mới và select vào item tương ứng có trong data
		 */
		value: {
			immediate: true,
			handler(newVal, oldVal) {
				const me = this;
				if (newVal != null && newVal != undefined) {
					me.internalValue = newVal;
					if (
						!me.internalSelectedItem ||
						me.internalSelectedItem[me.valueField] !== newVal
					) {
						if (me.internalDataSource != me.data) {
							me.initData();
						}
						me.doHightlightItem();
						if (me.typeAheadPointer >= 0) {
							me.setInternalItem(
								me.internalDataSource[me.typeAheadPointer],
								false
							);
						} else {
							if (!me.forceSelection && me.valueField == me.displayField) {
								me.setInternalText(me.internalValue);
							}
						}
					}
				} else {
					me.reset();
				}
			},
		},
	},
};
</script>
<style lang="scss" scoped>
@media screen and (max-width: 1366px) {
	@import '@/assets/scss/_sm-variables.scss';
	@import '@/assets/scss/components/msCombo.scss';
}
@media screen and (min-width: 1367px) {
	@import '@/assets/scss/_variables.scss';
	@import '@/assets/scss/components/msCombo.scss';
}
</style>
